import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "@/hooks/useTranslation";
import { setWindowTitle } from "@/lib/window-title";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function ProspectingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<string>("search");

  const tabList = [
    {
      label: t("prospecting.tabs.search"),
      value: "search",
    },
    {
      label: t("prospecting.tabs.history"),
      value: "history",
    },
  ];

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    navigate(value);
  };

  useEffect(() => {
    const paths = location.pathname.replace("/prospecting", "").split("/");
    if (paths.length <= 1) {
      navigate("search");
      return;
    }

    const relevantPath = paths.find((p) => tabList.some((tab) => tab.value === p)) ?? "search";
    setActiveTab(relevantPath);
  }, [location.pathname, activeTab]);

  useEffect(() => {
    setWindowTitle(
      tabList.find((tab) => tab.value === activeTab)?.label || "Prospection"
    );
  }, [activeTab]);

  return (
    <div className="mt-[-3px]">
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList className="justify-start w-full rounded-none bg-gradient-1">
          {tabList.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="data-[state=active]:bg-majorelle data-[state=active]:text-majorelle-foreground text-white/60"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {/* Under the header and the tab bar (`TabsList`, h-9). */}
      <div className="absolute top-[calc(var(--app-header-height)+2.25rem+1px)] left-0 flex-1 w-full h-[calc(100%-var(--app-header-height)-2.25rem-1px)] overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
